import { ProgressNoteData } from "@/modules/patients/detail/progress-note/types/progress-note-fragment-type"
import { CareProviderSearchType } from "@/types/__generated__/union-types"

type ProgressNotePointOfCare = ProgressNoteData["pointOfCare"]

type CareProviderSearchFilter = {
  searchType: CareProviderSearchType
  specialtyId: string | undefined
}

export const getCareProviderSearchFilter = (pointOfCare: ProgressNotePointOfCare): CareProviderSearchFilter => {
  const specialtyId = pointOfCare?.__typename === "ch_PointOfCare" ? pointOfCare.careProviderSpecialty?.id : undefined
  const hasSpecialty = Boolean(pointOfCare?.specialtyId)
  const effectivePointOfCare = pointOfCare?.actual ?? pointOfCare?.medical

  if (effectivePointOfCare === "GENERAL_PRACTITIONER") {
    return { searchType: "GENERAL_PRACTITIONER", specialtyId }
  }

  if (effectivePointOfCare === "SPECIALIST") {
    return { searchType: hasSpecialty ? "SPECIALIST_WITH_SPECIALTY" : "SPECIALIST_WITHOUT_SPECIALTY", specialtyId }
  }

  if (effectivePointOfCare === "HOSPITAL_ELECTIVE") {
    return {
      searchType: hasSpecialty ? "HOSPITAL_ELECTIVE_WITH_SPECIALTY" : "HOSPITAL_ELECTIVE_WITHOUT_SPECIALTY",
      specialtyId,
    }
  }

  if (effectivePointOfCare === "MEDICAL_EMERGENCY_OR_PERMANENCE") {
    return { searchType: "MEDICAL_EMERGENCY_OR_PERMANENCE", specialtyId }
  }

  if (effectivePointOfCare === "HOSPITAL_EMERGENCY_ROOM") {
    return { searchType: "HOSPITAL_EMERGENCY_ROOM", specialtyId }
  }

  return { searchType: "NONE", specialtyId }
}
